import {isString} from "lodash"

/**
 * Trims a value that is of a suitable type to be trimmed
 * @param {*} The value to trim
 * @returns {*} Either the trimmed string or the original value if it's not a string
 */
export const getTrimmed = (value) => {
  if (!isString(value)) {
    return value
  }

  return value.trim()
}
